import { render, staticRenderFns } from "./cancellation-feedback.vue?vue&type=template&id=f0939310&scoped=true"
import script from "./cancellation-feedback.vue?vue&type=script&lang=js"
export * from "./cancellation-feedback.vue?vue&type=script&lang=js"
import style0 from "./cancellation-feedback.vue?vue&type=style&index=0&id=f0939310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0939310",
  null
  
)

export default component.exports